import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

import { tpaColorName } from '../../../../../../utils/color';

export type TextStylesParams = {
  pageTitleFont: StyleParamType.Font;
  pageTitleColor: StyleParamType.Color;
  pageDescriptionFont: StyleParamType.Font;
  pageDescriptionColor: StyleParamType.Color;
  menuTitleFont: StyleParamType.Font;
  menuTitleColor: StyleParamType.Color;
  sectionTitleFont: StyleParamType.Font;
  sectionTitleColor: StyleParamType.Color;
  sectionDescriptionFont: StyleParamType.Font;
  sectionDescriptionColor: StyleParamType.Color;
  itemTitleFont: StyleParamType.Font;
  itemTitleColor: StyleParamType.Color;
  itemDescriptionFont: StyleParamType.Font;
  itemDescriptionColor: StyleParamType.Color;
  itemPriceFont: StyleParamType.Font;
  itemPriceColor: StyleParamType.Color;
  itemUnavailablePriceFont: StyleParamType.Font;
  itemUnavailablePriceColor: StyleParamType.Color;
};

export const textStylesParams = createStylesParams<TextStylesParams>({
  pageTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', { htmlTag: 'h2', size: 48 }),
  },
  pageTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-heading-2-color'), 1),
  },
  pageDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 16 }),
  },
  pageDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-paragraph-2-color'), 1),
  },
  menuTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', { htmlTag: 'h2', size: 32 }),
  },
  menuTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  sectionTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', { htmlTag: 'h2', size: 28 }),
  },
  sectionTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  sectionDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 16 }),
  },
  sectionDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  itemTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 16 }),
  },
  itemTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  itemDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 14 }),
  },
  itemDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  itemPriceFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 16 }),
  },
  itemPriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  itemUnavailablePriceFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 16 }),
  },
  itemUnavailablePriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-3', 1),
  },
});
